// 管理员模块
import AdminLayout from '@/layout/index.vue'
import AdminHome from '@/views/admin/home.vue'
import AdminList from '@/views/admin/list.vue'
import AdminDevicerecharge from '@/views/admin/devicerecharge.vue'
import AdminCompare from '@/views/admin/compare.vue'
import AdminAlarm from '@/views/admin/alarm.vue'
import AdminImport from '@/views/admin/import.vue'
import AdminAuth from '@/views/admin/auth.vue'
import AdminAddStation from '@/views/admin/add.vue'
import AdminUserManager from '@/views/admin/manager.vue'
import AdminMyInfo from '@/views/admin/myinfo.vue'
import AdminChangePwd from '@/views/admin/changepwd.vue'
import AdminTimeshare from '@/views/admin/timeshare.vue'
import AdminOfflinenotify from '@/views/admin/offlinenotify.vue'
import AdminCamera from '@/views/admin/camera.vue'

const router = {
  path: '/layout',
  name: 'adminLayout',
  component: AdminLayout,
  redirect: '/home',
  children: [
    {
      path: '/home',
      name: 'home',
      meta: {
        showTab: false,
        name: 'home',
        title: '蓝蜘蛛 系统概况'
      },
      component: AdminHome
    },
    {
      path: '/list',
      name: 'list',
      meta: {
        showTab: false,
        name: 'list',
        title: '蓝蜘蛛 系统列表'
      },
      component: AdminList
    },
    {
      path: '/devicerecharge',
      name: 'devicerecharge',
      meta: {
        showTab: true,
        name: 'devicerecharge',
        title: '蓝蜘蛛 设备充值'
      },
      component: AdminDevicerecharge
    },
    {
      path: '/compare',
      name: 'compare',
      meta: {
        showTab: false,
        name: 'compare',
        title: '蓝蜘蛛 系统比较'
      },
      component: AdminCompare
    },
    {
      path: '/alarm',
      name: 'alarm',
      meta: {
        showTab: false,
        name: 'alarm',
        title: '蓝蜘蛛 报警中心'
      },
      component: AdminAlarm
    },
    {
      path: '/import',
      name: 'import',
      meta: {
        showTab: false,
        name: 'import',
        title: '蓝蜘蛛 设备导入'
      },
      component: AdminImport
    },
    {
      path: '/auth',
      name: 'auth',
      meta: {
        showTab: false,
        name: 'auth',
        title: '蓝蜘蛛 设备授权'
      },
      component: AdminAuth
    },
    {
      path: '/add',
      name: 'add',
      meta: {
        showTab: false,
        name: 'add',
        title: '蓝蜘蛛 新增站点'
      },
      component: AdminAddStation
    },
    {
      path: '/manager',
      name: 'manager',
      meta: {
        showTab: false,
        name: 'manager',
        title: '蓝蜘蛛 用户管理'
      },
      component: AdminUserManager
    },
    {
      path: '/myinfo',
      name: 'myinfo',
      meta: {
        showTab: true,
        name: 'myinfo',
        title: '蓝蜘蛛 我的信息'
      },
      component: AdminMyInfo
    },
    {
      path: '/changepwd',
      name: 'changepwd',
      meta: {
        showTab: false,
        name: 'changepwd',
        title: '蓝蜘蛛 更改密码'
      },
      component: AdminChangePwd
    },
    {
      path: '/timeshare',
      name: 'timeshare',
      meta: {
        showTab: false,
        name: 'timeshare',
        title: '蓝蜘蛛 分时查询'
      },
      component: AdminTimeshare
    },
    {
      path: '/offlinenotify',
      name: 'offlinenotify',
      meta: {
        showTab: false,
        name: 'offlinenotify',
        title: '蓝蜘蛛 离线通知'
      },
      component: AdminOfflinenotify
    },
    {
      path: '/camera',
      name: 'camera',
      meta: {
        showTab: false,
        name: 'camera',
        title: '蓝蜘蛛 视频监控'
      },
      component: AdminCamera
    }
  ]
}

export default router
